<div class="container-lims-table">
    <span class="total-count">Tổng số bản ghi: <b>{{dataSource.data.length}}</b></span>
    <div class="right">
        <button mat-button [matMenuTriggerFor]="columnMenu" class="dropButton">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #columnMenu="matMenu" xPosition="before" class="dropButton">
            <mat-list (click)="$event.stopPropagation();" style="max-height: 300px;">
                <mat-list-item>
                    <mat-checkbox [(ngModel)]="master_checked" [(indeterminate)]="master_indeterminate"
                        (change)="master_change()"><b>{{ "Tất cả" }}</b></mat-checkbox>
                </mat-list-item>

                <mat-list-item *ngFor="let item of columns">
                    <mat-checkbox [(ngModel)]="item.checked" [disabled]="item.disabled"
                        [labelPosition]="item.labelPosition" (change)="list_change()">{{ item.name }}</mat-checkbox>
                </mat-list-item>

            </mat-list>
        </mat-menu>
        <mat-paginator #paginator [pageSize]="pageOptions[0]" [pageSizeOptions]="pageOptions" showFirstLastButtons
            id="mt-3">
        </mat-paginator>
    </div>
</div>
<div class="overflow-auto">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" matSortActive="carbs"
        matSortDirection="asc" matSortDisableClear id="table-content">

        <ng-container *ngFor="let column of columns" [cdkColumnDef]="column.key" class="mat-card">
            <th mat-header-cell *cdkHeaderCellDef [ngStyle]="{'max-width': column.maxWidth || 'none'}">{{ column.name }}
            </th>
            <td mat-cell *cdkCellDef="let row; let i = index"
                [ngClass]="['align-' + (column.alignment || 'left'), column.class ? column.class(row) : '']"
                [ngStyle]="{'max-width': column.maxWidth || 'none', 'white-space': column.maxWidth ? 'normal' : 'nowrap'}">
                <ng-container *ngIf="!column.buttons; else actionButtons">
                    <span [innerHTML]="column.cell(row, i) && column.cell(row, i) != 'null' ? column.cell(row, i) : ''">
                    </span>
                </ng-container>
                <ng-template #actionButtons>
                    <span *ngFor="let btn of column.buttons">
                        <button mat-icon-button *ngIf="!btn.show || btn.show(row)" [color]="btn.color || 'primary'"
                            (click)="btn.onClick(row)" [matTooltip]="btn.tooltip"
                            [ngClass]="btn.class ? btn.class(row) : ''">
                            <mat-icon>{{btn.icon}}</mat-icon>
                        </button>
                    </span>
                </ng-template>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.bg-row-delete]="row.is_delete == true"></tr>
    </table>
    <div *ngIf="dataSource.data.length === 0">{{ "Không có dữ liệu" }}</div>
</div>